/**
 * BETA — client (pharmacy customer) CRUD with debt enrichment.
 */
import { httpError } from "../router.js";
import { paginate, matchSearch, newId, nowIso } from "./_utils.js";

export function register(route) {
  route("GET", "/clients", (ctx) => {
    const { params, store } = ctx;
    let rows = [...store.data.clients];
    const q = params.q || params.search;
    if (q) {
      rows = rows.filter((c) =>
        matchSearch(c, q, ["nom", "prenom", "telephone", "cin", "carte_chifa"]),
      );
    }
    if (params.has_debt === "true" || params.has_debt === true) {
      const enriched = rows
        .map((c) => enrichDebt(c, store))
        .filter((c) => (c.total_debt || 0) > 0);
      return paginate(enriched, params);
    }
    return paginate(rows, params);
  });

  route("GET", "/clients/:id", (ctx) => {
    const c = ctx.store.data.clients.find((x) => x.id === ctx.params.id);
    if (!c) httpError(404, "Client introuvable", "NOT_FOUND");
    const ventes = ctx.store.data.ventes.filter((v) => v.client_id === c.id);
    const custodies = (ctx.store.data.instances?.custodies || []).filter(
      (cu) => cu.client_id === c.id,
    );
    return { ...enrichDebt(c, ctx.store), ventes, custodies };
  });

  route("POST", "/clients", (ctx) => {
    const body = ctx.body || {};
    if (!body.telephone && !body.cin) {
      httpError(400, "Téléphone ou CIN requis", "TELEPHONE_OR_CIN_REQUIRED");
    }
    const created = {
      id: newId("cli-new"),
      created_at: nowIso(),
      carte_chifa: null,
      carte_chifa_status: null,
      ...body,
    };
    ctx.store.data.clients.push(created);
    ctx.commit();
    return created;
  });

  route("PATCH", "/clients/:id", (ctx) => {
    const c = ctx.store.data.clients.find((x) => x.id === ctx.params.id);
    if (!c) httpError(404, "Client introuvable", "NOT_FOUND");
    Object.assign(c, ctx.body || {});
    ctx.commit();
    return c;
  });

  route("DELETE", "/clients/:id", (ctx) => {
    const c = ctx.store.data.clients.find((x) => x.id === ctx.params.id);
    if (!c) httpError(404, "Client introuvable", "NOT_FOUND");
    const debt = enrichDebt(c, ctx.store).total_debt;
    if (debt > 0) httpError(400, "Dette en cours empêche la suppression", "HAS_DEBT");
    ctx.store.data.clients = ctx.store.data.clients.filter((x) => x.id !== c.id);
    ctx.commit();
    return { success: true };
  });
}

function enrichDebt(client, store) {
  const list = store.data.instances?.list || [];
  const unpaid = list.filter(
    (i) => i.client_id === client.id && i.statut_paiement !== "PAYE",
  );
  const totalDebt = unpaid.reduce((s, i) => s + (i.montant_a_payer || 0), 0);
  const oldest = unpaid.length
    ? unpaid.reduce((a, b) => (a.date_vente < b.date_vente ? a : b)).date_vente
    : null;
  const cardsHeld = (store.data.instances?.custodies || []).filter(
    (cu) => cu.client_id === client.id && cu.statut === "HELD",
  ).length;
  return {
    ...client,
    total_debt: Math.round(totalDebt * 100) / 100,
    oldest_debt_date: oldest,
    cards_held_count: cardsHeld,
  };
}
